import { NeoState } from '../../Reducers.interface';

export const selectCurrencyList = (state: NeoState) => state?.payments?.currencies?.list || [];
export const selectCurrencyListLoading = (state: NeoState) => state?.payments?.currencies?.loading;
export const selectCurrencyListError = (state: NeoState) =>
  state?.payments?.currencies?.error || null;
